import { FC, useState } from 'react';
import classnames from 'classnames';

import { PlaceholderProps } from '@hh.ru/magritte-ui-placeholder/types';
import { getContainerStyles } from '@hh.ru/magritte-ui-placeholder/utils';
import { Title } from '@hh.ru/magritte-ui-title';

import styles from './placeholder.less';

const PLACEHOLDER_IMAGE_HEIGHT = 200;

export const Placeholder: FC<PlaceholderProps> = ({
    title,
    titleProps,
    description,
    maxWidth,
    minHeight,
    buttonPrimary,
    buttonSecondary,
    buttonTertiary,
    showButtons = true,
    paddingTop,
    paddingBottom,
    image,
    imageWidth,
    imageHeight,
    verticalAlign = 'center',
    buttonsStretched = true,
    buttonsAlign = 'center',
    'aria-label': ariaLabel,
    'data-qa': dataQa,
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadingError, setIsLoadingError] = useState(false);
    const containerStyles = getContainerStyles({ paddingTop, paddingBottom, maxWidth, minHeight });
    const hasAnyButton = !!(buttonPrimary || buttonSecondary || buttonTertiary);
    return (
        <div
            className={classnames(styles.placeholderContainer, {
                [styles.placeholderContainerVerticalAlignTop]: verticalAlign === 'top',
                [styles.placeholderContainerVerticalAlignCenter]: verticalAlign === 'center',
                [styles.placeholderContainerVerticalAlignBottom]: verticalAlign === 'bottom',
            })}
            style={containerStyles}
            data-qa={dataQa}
        >
            {!!image && (
                <div className={styles.placeholderImageContainer}>
                    <img
                        onLoad={() => {
                            setIsLoaded(true);
                        }}
                        onError={() => {
                            setIsLoaded(false);
                            setIsLoadingError(true);
                        }}
                        src={image}
                        alt={ariaLabel}
                        className={classnames(styles.placeholderImage, {
                            [styles.placeholderImageHidden]: isLoadingError,
                        })}
                        width={imageWidth}
                        height={!isLoaded && !imageHeight ? PLACEHOLDER_IMAGE_HEIGHT : imageHeight}
                    />
                </div>
            )}
            <Title size="medium" alignment="center" Element="h2" description={description} {...titleProps}>
                {title}
            </Title>
            {showButtons && hasAnyButton && (
                <div
                    className={classnames(styles.placeholderButtons, {
                        [styles.placeholderButtonsNoStretch]: !buttonsStretched,
                        [styles.placeholderButtonsAlignLeft]: buttonsAlign === 'left',
                        [styles.placeholderButtonsAlignCenter]: buttonsAlign === 'center',
                    })}
                >
                    {buttonPrimary}
                    {buttonSecondary}
                    {buttonTertiary}
                </div>
            )}
        </div>
    );
};
